import { PropsOf } from 'types';
import connect from './connect';
import LegacyAddTextModal from './LegacyAddTextModal';

export default connect(LegacyAddTextModal);
export type LegacyAddTextModalProps = PropsOf<ReturnType<typeof connect>>;
